import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { App_FormBloc, App_FormCreatorJson, App_FormSketchFormDynamique, App_FormStep } from 'src/app/utils/interfaces';
import { Type_App_Validator, Type_FieldOrLabel } from 'src/app/utils/types';

@Component({
  selector: 'app-c-modal-form-dynamique',
  templateUrl: './c-modal-form-dynamique.component.html',
  styleUrls: ['./c-modal-form-dynamique.component.scss'],
})
export class CModalFormDynamiqueComponent implements OnInit {
  @Input({ required: true }) modeShow!: boolean;

  @Input({ required: true }) formGroup!: FormGroup;
  @Input({ required: true }) formSketchFormDynamique!: App_FormSketchFormDynamique;

  @Input({ required: true }) forms!: FormGroup;
  @Input({ required: true }) blocName!: string;

  @Input({ required: true }) display!: App_FormCreatorJson; // TODO-pf? retirer + remplacer quand et si pertinent
  @Input({ required: true }) context!: 'preparation' | 'edition';

  @Input({ required: true }) observeSourcesArr!: { formControl: FormControl; validator: Type_App_Validator; }[]; // TODO-pf? retirer + remplacer quand et si pertinent

  @Input({ required: true }) step!: App_FormStep // TODO-pf? retirer + remplacer quand et si pertinent
  @Input({ required: true }) bloc!: App_FormBloc // TODO-pf? retirer + remplacer quand et si pertinent

  champs: Type_FieldOrLabel[] = [];

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {
    const champs = this.formSketchFormDynamique?.champs;
    if (Array.isArray(champs)) {
      this.champs = champs
    }
  }

  dismissModal() {
    this.modalController.dismiss()
  }

}
